<h5 mat-dialog-title>Edit Report &mdash; {{ reportName }}</h5>

<mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="name" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Type</mat-label>
        <mat-select [(ngModel)]="reportTypeId">
            <mat-option *ngFor="let type of reportTypes" [value]="type.id">
                {{ type.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Culture</mat-label>
        <mat-select [(ngModel)]="cultureId">
            <mat-option *ngFor="let culture of cultures" [value]="culture.id">
                {{ culture.text }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea matInput [(ngModel)]="description" rows="3"></textarea>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">Cancel</button>

    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!name">
        Save
    </button>
</mat-dialog-actions>
